module.exports = __webpack_public_path__ + "media/images/emblems/Romont_(Fribourg)-coat_of_arms-6888142372389d443f8bdf432394348e.svg";